import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';

// Initialize PDF.js worker as early as possible
import { isSetupSuccessful, pdfjsLib, isWorkerInitialized, ensureWorkerIsAvailable } from './setupPdfWorker';

// Log detailed PDF.js initialization info
console.log('PDF.js initialization:');
console.log('- Version:', pdfjsLib.version);
console.log('- Worker setup successful:', isSetupSuccessful);
console.log('- Worker source URL:', pdfjsLib.GlobalWorkerOptions?.workerSrc);
console.log('- Worker initialized:', isWorkerInitialized());

// Ensure worker is available
ensureWorkerIsAvailable();
console.log('Worker availability check completed');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
